export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle fillOpacity=".421" fill="#FFF" cx="17" cy="17" r="17" />
                <path d="M16.914 12.171a5.914 5.914 0 1 0 4.605 2.203" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" />
                <path stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="m15.258 10 2.512 2.261-2.261 2.512" />
            </g>
        </svg>
    );
}
